import { PaginationRequest } from '../config/common';

export class PaginationZoneRequest extends PaginationRequest {
    Country?: string = '';
    Supplier?: string = '';
    // SupplierID?: string;
    // ServiceName?: number;
    // Rate?: boolean;
}
export interface CreateZoneRequest {
    file?: any;
    SupplierID?: string;
    ServiceName?: number;
    Rate?: boolean;
}